const FILTER_TAG = 'tag';
const FILTER_STORY = 'story';
const FILTER_CATEGORY = 'category';

export type FilterType =
  typeof FILTER_TAG | typeof FILTER_STORY | typeof FILTER_CATEGORY;

export type FilterEntity = {
  id: string;
  title: string;
};

export type Filter = {
  type: FilterType;
} & Partial<Record<FilterType, FilterEntity>>;

const defaultFilters: FilterType[] = [FILTER_TAG, FILTER_STORY];

export { FILTER_TAG, FILTER_STORY, FILTER_CATEGORY, defaultFilters };
